import {ChangeDetectorRef, Component, forwardRef, HostListener} from "@angular/core";
import {NG_VALUE_ACCESSOR} from "@angular/forms";
import {FUIAbstractInput} from "../../../framework/abstract-input";

@Component({
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => FUIInlineTextareaInputComponent),
            multi: true
        }
    ],
    selector: "fui-inline-textarea-input",
    styleUrls: ["./inline-textarea-input.component.scss"],
    templateUrl: "./inline-textarea-input.component.html",
    standalone: false
})
export class FUIInlineTextareaInputComponent extends FUIAbstractInput {

    constructor(changeDetectorRef: ChangeDetectorRef) {
        super(changeDetectorRef);
    }

    /**
     * Perform events after a click on the host
     * @param element
     */
    @HostListener("click")
    override click(): void {
        this.focus();
    }
}
